module.exports = __webpack_public_path__ + "static/media/conference-catering-4.2df631e1.jpg";